import { twMerge } from 'tailwind-merge';

interface ProfileSectionProps {
  title?: string;
  children: React.ReactNode;
  className?: string;
}
const ProfileSection: React.FC<ProfileSectionProps> = ({
  title,
  children,
  className,
}) => {
  return (
    <div className={twMerge('py-2', className)}>
      <h1 className="text-sm py-2 text-iris-160 font-medium uppercase">
        {title}
      </h1>
      {children}
    </div>
  );
};
export default ProfileSection;
